import { render, staticRenderFns } from "./UserAccountList.vue?vue&type=template&id=4b1f8d4a"
import script from "./UserAccountList.vue?vue&type=script&lang=js"
export * from "./UserAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports